import { GET_INVOICE_DETAIL_DONE, GET_INVOICE_DETAIL_FAILED , RESET_INVOICE_PAYMENT_ERROR} from '../actions';
import { showMessage } from 'h-commons';

function currentInvoice(state = null, action) {
    switch (action.type) {
        case GET_INVOICE_DETAIL_DONE:
            return action.payload
        case GET_INVOICE_DETAIL_FAILED:
            showMessage({ message: `Failed to load invoice #${action.payload}`, type: 'error',});
            return state;
        case RESET_INVOICE_PAYMENT_ERROR:
            return { ...state, paymentFailureError:""};
        default:
            return state;
    }
}

export default currentInvoice;